// extracted by mini-css-extract-plugin
export default {"first-section":"_4LE6M"};